// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--R8ZjR","pulsate":"Button-module--pulsate--21MJL","white":"Button-module--white--xrH6z","blue":"Button-module--blue--3iYAr"};